/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitMenuOrderBody
 */
export interface SubmitMenuOrderBody {
    /**
     * 
     * @type {string}
     * @memberof SubmitMenuOrderBody
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitMenuOrderBody
     */
    hash?: string;
}

/**
 * Check if a given object implements the SubmitMenuOrderBody interface.
 */
export function instanceOfSubmitMenuOrderBody(value: object): value is SubmitMenuOrderBody {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function SubmitMenuOrderBodyFromJSON(json: any): SubmitMenuOrderBody {
    return SubmitMenuOrderBodyFromJSONTyped(json, false);
}

export function SubmitMenuOrderBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitMenuOrderBody {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'hash': json['hash'] == null ? undefined : json['hash'],
    };
}

export function SubmitMenuOrderBodyToJSON(json: any): SubmitMenuOrderBody {
    return SubmitMenuOrderBodyToJSONTyped(json, false);
}

export function SubmitMenuOrderBodyToJSONTyped(value?: SubmitMenuOrderBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'hash': value['hash'],
    };
}

